module.exports = require('./helpers/bundle-url').getBundleURL('hstjT') + "angle-left-solid.3468c917.svg";